var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDown = function SvgDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 333.203,
    height: 200,
    className: "down_svg__icon",
    viewBox: "0 0 1706 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M853.333 754.859 1506.304 82.26a82.773 82.773 0 0 1 118.784 0c33.11 34.134 33.11 88.235 0 122.368L932.523 918.187a87.7 87.7 0 0 1-18.262 25.6 82.6 82.6 0 0 1-60.928 23.21 82.6 82.6 0 0 1-79.189-48.81L81.579 204.8a87.893 87.893 0 0 1 1.706-124.075 82.773 82.773 0 0 1 117.078 1.707l652.97 672.256z"
  })));
};
export default SvgDown;